
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1wIcl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $9hlns = parcelRequire("9hlns");


var $3qtLb = parcelRequire("3qtLb");


var $7xVCs = parcelRequire("7xVCs");


var $jmjWc = parcelRequire("jmjWc");


var $epLE5 = parcelRequire("epLE5");


var $arWla = parcelRequire("arWla");

/**
 * @generated SignedSource<<e0d86f368f63b411ec27da87aa27eaf5>>
 * @relayHash 5bab448bc3cdbac51269b7753dbe9473
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b96a9b2a494ac08e1088f10ff4b3de0ecf86aa52c0b8ba1a2f3e157e7dc12782
const $962b95792488c989$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "navigationType"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "token"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "token"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "navigationType",
                    "variableName": "navigationType"
                },
                {
                    "kind": "Variable",
                    "name": "orderby",
                    "variableName": "sort"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "current"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasInheritedRestrictions"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "base"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceViewsDataContentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceViewsDataContentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "5bab448bc3cdbac51269b7753dbe9473",
            "id": "b96a9b2a494ac08e1088f10ff4b3de0ecf86aa52c0b8ba1a2f3e157e7dc12782",
            "metadata": {},
            "name": "useSpaceViewsDataContentQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsDataContentQuery($first:Int!,$spaceKey:String!,$token:String,$sort:String!,$navigationType:String){content(first:$first,spaceKey:$spaceKey,orderby:$sort,after:$token,status:\"current\",navigationType:$navigationType){nodes{id,title,type,subType,hasRestrictions,hasInheritedRestrictions,links{webui,base},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$962b95792488c989$var$node.hash = "b7c767d5947de22dcbf1640209fd1c2c";
var $962b95792488c989$export$2e2bcd8739ae039 = $962b95792488c989$var$node;



var $e5i8U = parcelRequire("e5i8U");





var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");

/**
 * @graphql agg
 */ 
var $eSUdr = parcelRequire("eSUdr");





var $abN8T = parcelRequire("abN8T");


var $j1Ss3 = parcelRequire("j1Ss3");


var $9wEpK = parcelRequire("9wEpK");





var $d4Pk4 = parcelRequire("d4Pk4");


var $gKr8t = parcelRequire("gKr8t");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $c7GB4 = parcelRequire("c7GB4");


var $1ggpj = parcelRequire("1ggpj");


var $fdNea = parcelRequire("fdNea");


var $6a9Hv = parcelRequire("6a9Hv");

const $d84f561e75dd61f1$export$acb983bf51f2874b = (remoteEdges, localActivity, { expirationSeconds: expirationSeconds })=>{
    const mergedEdges = [];
    let latestExpiration;
    const processedRemoteEventContentIds = new Set();
    const consistentContentIds = new Set();
    const pushIfNotDeleted = (edge)=>{
        if (!localActivity.deletedContentIds.has(edge.node?.object?.content?.id || '')) mergedEdges.push(edge);
    };
    const expirationThreshold = $d84f561e75dd61f1$var$secondsAgo(expirationSeconds);
    const processAndPushLocalEvent = (localEvent)=>{
        pushIfNotDeleted($d84f561e75dd61f1$var$toMyVisitsEdge(localEvent));
        const localEventTime = new Date(localEvent.timestamp);
        if (!latestExpiration && localEventTime <= expirationThreshold) {
            latestExpiration = localEventTime;
            latestExpiration.setSeconds(latestExpiration.getSeconds() + expirationSeconds);
        }
        // If a remote event with the same content ID has already been processed, we know the event is consistent
        const contentId = localEvent.content.id || '';
        if (processedRemoteEventContentIds.has(contentId)) consistentContentIds.add(contentId);
    };
    const processAndPushRemoteEvent = (remoteEdge)=>{
        pushIfNotDeleted(remoteEdge);
        processedRemoteEventContentIds.add(remoteEdge.node?.object?.content?.id || '');
    };
    let remoteIndex = 0;
    let localIndex = 0;
    // Iterate remote and local viewed events at the same time, pushing to
    // mergedEdges whichever edge has a newer timestamp (if it hasn't been deleted)
    while(remoteIndex < remoteEdges.length || localIndex < localActivity.viewedEvents.length){
        const remoteEdge = remoteEdges[remoteIndex];
        const localEvent = localActivity.viewedEvents[localIndex];
        if (!localEvent) {
            processAndPushRemoteEvent(remoteEdge);
            remoteIndex++;
        } else if (!remoteEdge) {
            processAndPushLocalEvent(localEvent);
            localIndex++;
        } else {
            const remoteTimestamp = remoteEdge?.node?.timestamp;
            const localTimestamp = localEvent.timestamp;
            if (!remoteTimestamp || new Date(localTimestamp) >= new Date(remoteTimestamp)) {
                processAndPushLocalEvent(localEvent);
                localIndex++;
            } else {
                processAndPushRemoteEvent(remoteEdge);
                remoteIndex++;
            }
        }
    }
    return {
        mergedNodes: (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(mergedEdges, (edge)=>edge.node?.object?.content?.id),
        latestExpiration: latestExpiration,
        consistentContentIds: consistentContentIds
    };
};
const $d84f561e75dd61f1$var$toMyVisitsEdge = (event)=>{
    const id = event.content.id || '';
    const name = 'title' in event.content ? event.content.title ?? null : null;
    return {
        cursor: '',
        node: {
            id: id,
            timestamp: event.timestamp,
            object: {
                id: id,
                name: name,
                localResourceId: id,
                content: event.content
            }
        }
    };
};
const $d84f561e75dd61f1$var$secondsAgo = (n)=>{
    const date = new Date();
    date.setSeconds(date.getSeconds() - n);
    return date;
};



var $iA9co = parcelRequire("iA9co");

var $f9c3f81e43b0c6b9$require$Buffer = $iA9co.Buffer;
// Do not remove the 'confluence_' prefix as it is required for the query to work in AGG
// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming
const $f9c3f81e43b0c6b9$var$useMyVisitsLocalActivityMyVisitsQuery = (0, $eSUdr.default)`query confluence_useMyVisitsLocalActivityMyVisitsQuery($cloudId:ID!$first:Int!$after:String$spaceId:ID!){activities{myActivities{viewed(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:[PAGE]cloudIds:[$cloudId]containerIds:[$spaceId]}}]first:$first after:$after){edges{node{id timestamp object{id localResourceId name content{title id title space{id key}properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id value key version{number}}}}}}cursor}pageInfo{hasNextPage}}}}}`;
const $f9c3f81e43b0c6b9$var$useMyVisitsLocalActivityMyVisitsQueryV3 = (0, $eSUdr.default)`query useMyVisitsLocalActivityMyVisitsQuery($cloudId:ID!$first:Int!$after:String$spaceId:ID!$objectTypes:[String!]$eventTypes:[String!]){activity{myActivity{all(filter:{type:AND rootContainerIds:[$cloudId]arguments:{products:["CONFLUENCE"]objectTypes:$objectTypes eventTypes:$eventTypes containerIds:[$spaceId]}}first:$first after:$after){edges{node{id object{id data{...on ConfluencePage{id title space{id key}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}}}event{id timestamp eventType}}cursor}pageInfo{hasNextPage}}}}}`;
const $f9c3f81e43b0c6b9$var$EVENT_EXPIRATION_SECONDS = 60;
const $f9c3f81e43b0c6b9$var$useMerge = (remoteEdges, localActivity, shouldMerge)=>{
    if (!shouldMerge) return {};
    return (0, $d84f561e75dd61f1$export$acb983bf51f2874b)(remoteEdges, localActivity, {
        expirationSeconds: $f9c3f81e43b0c6b9$var$EVENT_EXPIRATION_SECONDS
    });
};
const $f9c3f81e43b0c6b9$var$useRefetch = (apolloRefetch, loading, remoteEdges, localActivity, consistentContentIds, latestExpiration)=>{
    const didRefetch = (0, $42omo.useRef)(false);
    const prevLatestExpiration = (0, $42omo.useRef)();
    const refetch = (0, $42omo.useCallback)(()=>{
        didRefetch.current = true;
        apolloRefetch();
    }, [
        apolloRefetch
    ]);
    // Analytics & mark events as consistent when backend catches up
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (didRefetch.current && !loading && consistentContentIds) {
            didRefetch.current = false;
            consistentContentIds.forEach((contentId)=>{
                localActivity.markAsConsistent(contentId);
            });
            const localActivityCount = localActivity.viewedEvents.length;
            const newlyConsistentCount = consistentContentIds.size;
            const inconsistencyCount = localActivityCount - consistentContentIds.size;
            const activityPlatformCount = remoteEdges.length;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    actionSubject: 'useMyVisits',
                    action: 'refetched',
                    source: 'spaceViews',
                    attributes: {
                        localActivityCount: localActivityCount,
                        newlyConsistentCount: newlyConsistentCount,
                        inconsistencyCount: inconsistencyCount,
                        activityPlatformCount: activityPlatformCount
                    }
                }
            }).fire();
        }
    });
    // Refetch on event expiration
    (0, $42omo.useEffect)(()=>{
        if (latestExpiration && (!prevLatestExpiration.current || latestExpiration > prevLatestExpiration.current)) {
            prevLatestExpiration.current = latestExpiration;
            refetch();
        }
    });
    return refetch;
};
// Activity platform no longer stores UGC.
// This means we need to map the ccgraphql hydrated title to the, now missing, object name.
// Please see:
//   - https://hello.atlassian.net/browse/COMMIT-3691
//   - https://product-fabric.atlassian.net/wiki/spaces/YW/pages/3390835304/LDR+De-risking+Consumer+Migration+w.r.t.+Confluence
const $f9c3f81e43b0c6b9$var$transformActivityPlatformLegacyUgcRemovalMitigationResponse = (activitiesData)=>activitiesData?.activities?.myActivities?.viewed?.edges === undefined ? activitiesData : {
        ...activitiesData,
        activities: {
            ...activitiesData.activities,
            myActivities: {
                ...activitiesData.activities?.myActivities,
                viewed: {
                    ...activitiesData.activities?.myActivities?.viewed,
                    edges: [
                        ...activitiesData.activities?.myActivities?.viewed?.edges ?? []
                    ].map((edge)=>({
                            ...edge,
                            node: {
                                ...edge?.node,
                                object: {
                                    ...edge?.node?.object,
                                    name: edge?.node?.object?.content?.title
                                }
                            }
                        }))
                }
            }
        }
    };
const $f9c3f81e43b0c6b9$var$transformActivityPlatformLegacyUgcRemovalMitigationResponseV3 = (activitiesData)=>{
    if (!activitiesData?.activity?.myActivity?.all?.edges) return undefined;
    const edges = activitiesData.activity.myActivity.all.edges;
    const transformedEdges = edges.map((edge)=>{
        const { node: node } = edge;
        const pageData = node?.object?.data?.__typename === 'ConfluencePage' ? node.object.data : null;
        const metadata = pageData?.metadata;
        const nodeId = (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: pageData?.id || '',
            resourceType: (0, $1ggpj.ContentType).PAGE
        }) || '';
        const emojiProperties = [
            {
                id: 'emoji-title-published',
                key: 'emoji-title-published',
                value: metadata?.titleEmojiPublished?.value,
                version: null
            },
            {
                id: 'emoji-title-draft',
                key: 'emoji-title-draft',
                value: metadata?.titleEmojiDraft?.value,
                version: null
            }
        ].filter((prop)=>prop.value);
        return {
            cursor: edge.cursor,
            node: {
                id: nodeId,
                timestamp: node?.event?.timestamp ? String(node.event.timestamp) : null,
                object: {
                    id: node.object.id,
                    localResourceId: nodeId,
                    name: pageData?.title,
                    content: pageData && {
                        id: nodeId,
                        title: pageData.title,
                        space: pageData.space,
                        properties: emojiProperties.length > 0 ? {
                            nodes: emojiProperties
                        } : null
                    }
                }
            }
        };
    });
    return {
        activities: {
            myActivities: {
                viewed: {
                    edges: transformedEdges,
                    pageInfo: activitiesData.activity.myActivity.all.pageInfo
                }
            }
        }
    };
};
const $f9c3f81e43b0c6b9$var$useQueryActivityPlatform = ({ skip: skip, pageSize: pageSize = 25, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, fetchMore: fetchMore, error: error, refetch: refetch, networkStatus: networkStatus } = (0, $j1Ss3.useQuery)((0, $6mKj3.expValEquals)('cc_migrate_remaining_activity_v2_queries_to_v3', 'isEnabled', true) ? $f9c3f81e43b0c6b9$var$useMyVisitsLocalActivityMyVisitsQueryV3 : $f9c3f81e43b0c6b9$var$useMyVisitsLocalActivityMyVisitsQuery, {
        skip: skip,
        variables: (0, $6mKj3.expValEquals)('cc_migrate_remaining_activity_v2_queries_to_v3', 'isEnabled', true) ? {
            first: pageSize,
            spaceId: $f9c3f81e43b0c6b9$var$getSpaceAriV3(spaceKey, cloudId),
            after: '',
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            objectTypes: [
                'PAGE'
            ],
            eventTypes: [
                'VIEWED'
            ]
        } : {
            first: pageSize,
            spaceId: $f9c3f81e43b0c6b9$var$getSpaceId(spaceKey, cloudId),
            after: '',
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy,
        notifyOnNetworkStatusChange: true,
        ...(0, $6mKj3.expValEquals)('cc_migrate_remaining_activity_v2_queries_to_v3', 'isEnabled', true) && {
            client: (0, $gKr8t.getAGGClient)()
        }
    });
    return {
        data: (0, $6mKj3.expValEquals)('cc_migrate_remaining_activity_v2_queries_to_v3', 'isEnabled', true) ? $f9c3f81e43b0c6b9$var$transformActivityPlatformLegacyUgcRemovalMitigationResponseV3(data) : $f9c3f81e43b0c6b9$var$transformActivityPlatformLegacyUgcRemovalMitigationResponse(data),
        loading: loading,
        fetchMore: fetchMore,
        error: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
const $f9c3f81e43b0c6b9$export$57cd3373d1e83ab8 = (options)=>{
    const { spaceKey: spaceKey, skip: skip } = options;
    const { data: remoteData, loading: loading, fetchMore: fetchMore, error: error, refetch: apolloRefetch, networkStatus: networkStatus } = $f9c3f81e43b0c6b9$var$useQueryActivityPlatform(options);
    const remoteEdges = (remoteData?.activities?.myActivities?.viewed?.edges || []).filter($f9c3f81e43b0c6b9$var$inSpaceAndNotNull(spaceKey));
    const hasNextPage = Boolean(remoteData?.activities?.myActivities?.viewed?.pageInfo.hasNextPage) && remoteEdges.length > 0;
    const after = remoteEdges[remoteEdges.length - 1]?.cursor;
    const nextPage = (0, $42omo.useCallback)(async ()=>{
        if (!hasNextPage || !after) return;
        await fetchMore({
            variables: {
                after: after
            },
            updateQuery: (prevResult, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult) return prevResult;
                const result = {
                    ...fetchMoreResult
                };
                if ((0, $6mKj3.expValEquals)('cc_migrate_remaining_activity_v2_queries_to_v3', 'isEnabled', true)) {
                    const prevEdges = prevResult?.activity?.myActivity?.all?.edges || [];
                    const fetchMoreEdges = fetchMoreResult?.activity?.myActivity?.all?.edges || [];
                    (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'activity.myActivity.all.edges', [
                        ...prevEdges,
                        ...fetchMoreEdges
                    ]);
                } else {
                    const prevEdges = prevResult.activities?.myActivities?.viewed?.edges || [];
                    const fetchMoreEdges = fetchMoreResult.activities?.myActivities?.viewed?.edges || [];
                    (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'activities.myActivities.viewed.edges', [
                        ...prevEdges,
                        ...fetchMoreEdges
                    ]);
                }
                return result;
            }
        });
    }, [
        fetchMore,
        hasNextPage,
        after
    ]);
    const localActivity = (0, $fdNea.useLocalActivity)({
        skip: skip,
        filters: {
            spaceKey: spaceKey
        }
    });
    const shouldMerge = !skip && networkStatus !== (0, $9wEpK.NetworkStatus).loading && Boolean(remoteData);
    const { mergedNodes: mergedNodes, latestExpiration: latestExpiration, consistentContentIds: consistentContentIds } = $f9c3f81e43b0c6b9$var$useMerge(remoteEdges, localActivity, shouldMerge);
    const data = mergedNodes && {
        edges: mergedNodes,
        hasNextPage: hasNextPage
    };
    const refetch = $f9c3f81e43b0c6b9$var$useRefetch(apolloRefetch, loading, remoteEdges, localActivity, consistentContentIds, latestExpiration);
    return {
        data: data,
        loading: loading,
        error: error,
        nextPage: nextPage,
        refetch: refetch
    };
};
const $f9c3f81e43b0c6b9$var$inSpaceAndNotNull = (spaceKey)=>(edge)=>Boolean(edge && edge.node?.object?.content?.space?.key === spaceKey);
/*
 * Get the spaceID used to filter Activity Platform results
 * ContainerIDs are a Base64 encoded strings of the form:
 * ari:cloud:confluence:{cloudId}:space/${spaceSlug}
 * Where spaceSlug is a hex string of the form: v1/{cloudId}/{spaceKey}
 */ const $f9c3f81e43b0c6b9$var$getSpaceId = (spaceKey, cloudId)=>{
    const hexEncodedSpace = $f9c3f81e43b0c6b9$require$Buffer.from(`v1/${cloudId}/${spaceKey}`, 'ascii').toString('hex');
    return btoa(`ari:cloud:confluence:${cloudId}:space/${hexEncodedSpace}`);
};
const $f9c3f81e43b0c6b9$var$getSpaceAriV3 = (spaceKey, cloudId)=>{
    const hexEncodedSpace = $f9c3f81e43b0c6b9$require$Buffer.from(`v1/${cloudId}/${spaceKey}`, 'ascii').toString('hex');
    return `ari:cloud:confluence:${cloudId}:space/${hexEncodedSpace}`;
};



var $8rneB = parcelRequire("8rneB");


var $brn6e = parcelRequire("brn6e");

const $ace8b33bca6d1042$var$PAGE_SIZE = 100;
const $ace8b33bca6d1042$var$FETCH_POLICY = 'cache-and-network';
const $ace8b33bca6d1042$var$ALPHA_TITLE_SORT = 'title';
const $ace8b33bca6d1042$var$LAST_MODIFIED_SORT = 'history.by.when desc';
const $ace8b33bca6d1042$var$CONTENT_TREE_NAV_TYPE = 'contentTree';
const $ace8b33bca6d1042$export$83676b76e7165b8b = (0, $e5i8U.default);
const $ace8b33bca6d1042$var$useSpaceViewsDataContentQuery = (0, $962b95792488c989$export$2e2bcd8739ae039);
const $ace8b33bca6d1042$export$67db58d21459ad4 = (sort)=>{
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // @ts-ignore FIXME: `stateSpaceKey` can be `undefined` here, and needs proper handling
    const spaceKey = stateSpaceKey;
    const [paginationError, setPaginationError] = (0, $42omo.useState)();
    const [paginationLoading, setPaginationLoading] = (0, $42omo.useState)(false);
    const isSearch = sort === 'TITLE_AZ' || sort === 'RECENTLY_MODIFIED';
    const isRecent = sort == 'RECENTLY_VIEWED';
    const { data: spaceRootData, loading: spaceRootLoading, error: spaceRootError, refetch: spaceRootRefetch } = (0, $jMyy4.useQueryInterop)($ace8b33bca6d1042$export$83676b76e7165b8b, {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: $ace8b33bca6d1042$var$FETCH_POLICY
    });
    const { data: searchData, loading: searchLoading, fetchMore: searchFetchMore, error: searchError, refetch: searchRefetch } = (0, $jMyy4.useQueryInterop)($ace8b33bca6d1042$var$useSpaceViewsDataContentQuery, {
        variables: {
            first: $ace8b33bca6d1042$var$PAGE_SIZE,
            spaceKey: spaceKey,
            sort: sort === 'TITLE_AZ' ? $ace8b33bca6d1042$var$ALPHA_TITLE_SORT : $ace8b33bca6d1042$var$LAST_MODIFIED_SORT,
            navigationType: $ace8b33bca6d1042$var$CONTENT_TREE_NAV_TYPE
        },
        skip: !isSearch,
        fetchPolicy: $ace8b33bca6d1042$var$FETCH_POLICY
    });
    const { data: recentData, loading: recentLoading, nextPage: recentFetchMore, error: recentError, refetch: recentRefetch } = (0, $f9c3f81e43b0c6b9$export$57cd3373d1e83ab8)({
        spaceKey: spaceKey,
        pageSize: $ace8b33bca6d1042$var$PAGE_SIZE,
        skip: !isRecent,
        fetchPolicy: $ace8b33bca6d1042$var$FETCH_POLICY
    });
    const spaceRootId = spaceRootData?.space?.homepage?.id || null;
    const data = (0, $42omo.useMemo)(()=>{
        const { pagesList: pagesList, pageInfo: pageInfo } = $ace8b33bca6d1042$export$7032d5e916820819(searchData || recentData) || {};
        return {
            pagesList: (pagesList ?? []).filter((item)=>item?.id !== spaceRootId),
            pageInfo: pageInfo
        };
    }, [
        spaceRootId,
        searchData,
        recentData
    ]);
    const refetch = isSearch ? ()=>{
        spaceRootRefetch();
        searchRefetch();
    } : isRecent ? ()=>{
        spaceRootRefetch();
        recentRefetch();
    } : undefined;
    const loading = searchLoading || recentLoading || paginationLoading || spaceRootLoading;
    const fetchMore = (0, $42omo.useCallback)(()=>{
        const { hasNextPage: hasNextPage, endCursor: endCursor } = data?.pageInfo || {};
        if (hasNextPage && endCursor) {
            if (!loading) {
                /**
         * We maintain a separate pagination loading state because of the separate error state.
         * Without this, the hook would return `loading: false` before the error state has been updated
         */ setPaginationLoading(true);
                if (isSearch) searchFetchMore({
                    variables: {
                        token: endCursor
                    },
                    updateQuery: (prevResult, { fetchMoreResult: fetchMoreResult })=>{
                        if (!fetchMoreResult) return prevResult;
                        const prevNodes = prevResult?.content?.nodes || [];
                        const results = {
                            ...fetchMoreResult
                        };
                        if (results?.content) {
                            if (results.content?.nodes) results.content.nodes = prevNodes.concat(results.content.nodes);
                            else results.content.nodes = prevNodes;
                        }
                        return results;
                    }
                }).catch((error)=>{
                    setPaginationError(error);
                }).finally(()=>{
                    setPaginationLoading(false);
                });
                else if (isRecent) recentFetchMore().catch((error)=>{
                    setPaginationError(error);
                }).finally(()=>{
                    setPaginationLoading(false);
                });
            }
        }
    }, [
        searchFetchMore,
        recentFetchMore,
        data?.pageInfo,
        isRecent,
        isSearch,
        loading,
        setPaginationError
    ]);
    const error = searchError || recentError || paginationError || spaceRootError;
    return {
        data: data,
        fetchMore: fetchMore,
        loading: loading,
        error: error,
        refetch: refetch
    };
};
const $ace8b33bca6d1042$export$7032d5e916820819 = (data)=>{
    if (!data) return data;
    if ($ace8b33bca6d1042$var$isSearchData(data)) return $ace8b33bca6d1042$export$ae86fae5ef1cb4cb(data);
    if ($ace8b33bca6d1042$var$isLocalActivitiesData(data)) return $ace8b33bca6d1042$var$normalizeActivities(data);
};
const $ace8b33bca6d1042$var$isSearchData = (data)=>Boolean(data.content);
const $ace8b33bca6d1042$var$isLocalActivitiesData = (data)=>Boolean(data.edges);
function $ace8b33bca6d1042$var$isNotNull(data) {
    return data != null;
}
// Folders (especially without a view) don't make a whole lot of sense in the context of space views; as they are
// inherently a part of the tree view without a dedicated view of their own. So we filter them out.
function $ace8b33bca6d1042$var$isNotFolder(data) {
    return data?.type != null && data?.type !== 'folder';
}
const $ace8b33bca6d1042$export$ae86fae5ef1cb4cb = (data)=>{
    const pagesList = (data.content?.nodes || []).filter($ace8b33bca6d1042$var$isNotNull).filter($ace8b33bca6d1042$var$isNotFolder).map((content)=>{
        const { id: id, hasRestrictions: hasRestrictions, hasInheritedRestrictions: hasInheritedRestrictions } = content || {};
        const emojiPublished = (0, $8rneB.getEmojiPublishedProperty)(content);
        const emojiDraft = (0, $8rneB.getEmojiDraftProperty)(content);
        const { text: title, emoji: displayEmoji } = (0, $brn6e.getTitleAndEmoji)(content?.title || '', emojiPublished?.value);
        return {
            title: title,
            id: id,
            hasRestrictions: hasRestrictions,
            hasInheritedRestrictions: hasInheritedRestrictions,
            displayEmoji: displayEmoji,
            emojiPublished: emojiPublished,
            emojiDraft: emojiDraft,
            type: content?.type ?? undefined,
            subType: content?.subType ?? undefined
        };
    });
    const pageInfo = {
        hasNextPage: Boolean(data.content?.pageInfo?.hasNextPage),
        endCursor: data.content?.pageInfo?.endCursor || null
    };
    return {
        pagesList: pagesList,
        pageInfo: pageInfo
    };
};
const $ace8b33bca6d1042$var$normalizeActivities = (data)=>{
    const edges = data?.edges || [];
    const pagesList = edges.map((edge)=>{
        const object = edge?.node?.object;
        const content = object?.content;
        const emojiPublished = (0, $8rneB.getEmojiPublishedProperty)(content);
        const emojiDraft = (0, $8rneB.getEmojiDraftProperty)(content);
        const { text: title, emoji: displayEmoji } = (0, $brn6e.getTitleAndEmoji)(content?.title || '', emojiPublished?.value);
        return {
            title: title,
            id: object?.localResourceId || null,
            displayEmoji: displayEmoji,
            emojiPublished: emojiPublished,
            emojiDraft: emojiDraft
        };
    });
    const pageInfo = {
        hasNextPage: Boolean(data?.hasNextPage),
        endCursor: edges[edges.length - 1]?.cursor || null
    };
    return {
        pagesList: pagesList,
        pageInfo: pageInfo
    };
};



const $abad8274ab193bca$var$SpaceViewsErrorLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WE8mr",
    name: "SpaceViewsErrorLoader",
    loader: async ()=>(await (parcelRequire("ifD3G"))).SpaceViewsError
});

const $abad8274ab193bca$var$SpaceViewsNoResultsLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r41aH",
    name: "SpaceViewsNoResultsLoader",
    loader: async ()=>(await (parcelRequire("ifD3G"))).SpaceViewsNoResults
});

const $abad8274ab193bca$var$SpaceViewsCurrentViewIndicatorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "h-7Sy",
    name: "SpaceViewsCurrentViewIndicatorLoader",
    loader: async ()=>(await (parcelRequire("9XDXQ"))).SpaceViewsCurrentViewIndicator
});

const $abad8274ab193bca$var$ViewMoreButtonLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "a7foZ",
    name: "ViewMoreButtonLoader",
    loader: async ()=>(await (parcelRequire("xzydI"))).ViewMoreButton
});

const $abad8274ab193bca$var$SpaceViewsListLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "sFx5S",
    name: "SpaceViewsListLoader",
    loader: async ()=>(await (parcelRequire("4LZuC"))).SpaceViewsList
});

const $abad8274ab193bca$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("cXwni"))).fireItemClickedAnalytics);
const $abad8274ab193bca$export$551e683b9e0018c4 = ({ spaceViewsSort: spaceViewsSort, setIsSpaceViewsLoading: setIsSpaceViewsLoading, setSpaceViewsError: setSpaceViewsError, trackedSetSpaceViewsSort: trackedSetSpaceViewsSort, makeTrackedFetchMore: makeTrackedFetchMore, spaceKey: spaceKey, contentId: contentId, shouldRenderAfterIcon: shouldRenderAfterIcon, contentTreeSize: contentTreeSize, onContentTreeLoadComplete: onContentTreeLoadComplete = ()=>{}, onSpaceViewCleared: onSpaceViewCleared, ...hoverPageCardProps })=>{
    const clearHighlightTimeout = (0, $42omo.useRef)(setTimeout(()=>{}, 0));
    const setClearHighlightTimeout = (0, $42omo.useCallback)((pageTreeStateUpdater)=>{
        clearHighlightTimeout.current = setTimeout(()=>{
            pageTreeStateUpdater.clearHighlightedPages();
        }, (0, $3qtLb.ANIMATE_TIME_SEC) * 1000);
    }, [
        clearHighlightTimeout
    ]);
    const [highlightedPages, setHighlightedPages] = (0, $42omo.useState)([]);
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, refetch: refetch } = (0, $ace8b33bca6d1042$export$67db58d21459ad4)(spaceViewsSort);
    const pagesList = data?.pagesList;
    (0, $42omo.useEffect)(()=>{
        setIsSpaceViewsLoading(loading);
        if (!loading) onContentTreeLoadComplete();
    }, [
        setIsSpaceViewsLoading,
        loading,
        onContentTreeLoadComplete
    ]);
    (0, $42omo.useEffect)(()=>{
        setSpaceViewsError(error);
    }, [
        setSpaceViewsError,
        error
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onItemClick = $abad8274ab193bca$var$useLazyClickAnalytics(createAnalyticsEvent, spaceViewsSort, contentTreeSize);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($abad8274ab193bca$var$SpaceViewsCurrentViewIndicatorLoader, {
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: trackedSetSpaceViewsSort,
        onSpaceViewCleared: onSpaceViewCleared
    }), pagesList?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($abad8274ab193bca$var$SpaceViewsListLoader, {
        pagesList: pagesList,
        spaceKey: spaceKey,
        contentId: contentId,
        onItemClick: onItemClick,
        shouldRenderAfterIcon: shouldRenderAfterIcon,
        ...hoverPageCardProps
    }) : !error && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($abad8274ab193bca$var$SpaceViewsNoResultsLoader, null), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arWla.FlexCenter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium"
    })) : error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($abad8274ab193bca$var$SpaceViewsErrorLoader, {
        error: error
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($abad8274ab193bca$var$ViewMoreButtonLoader, {
        fetchMore: makeTrackedFetchMore(fetchMore),
        hasMore: Boolean(data?.pageInfo?.hasNextPage),
        loading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageTreeStateUpdater)=>{
        if (refetch && (pageTreeStateUpdater.state.forceFetchPageId || pageTreeStateUpdater.state.highlightPagesIds.length !== highlightedPages.length)) {
            if (pageTreeStateUpdater.state.highlightPagesIds.length !== highlightedPages.length) {
                setHighlightedPages(pageTreeStateUpdater.state.highlightPagesIds);
                if (pageTreeStateUpdater.state.highlightPagesIds.length > 0) {
                    clearHighlightTimeout.current && clearTimeout(clearHighlightTimeout.current);
                    setClearHighlightTimeout(pageTreeStateUpdater);
                }
            }
            refetch();
            pageTreeStateUpdater.clearForceFetch();
        }
        return null;
    }));
};
module.exports["SpaceViews"] = $abad8274ab193bca$export$551e683b9e0018c4;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("e5i8U", function(module, exports) {
/**
 * @generated SignedSource<<51852880959f49099a589a37c1b7d75e>>
 * @relayHash e2df23bdc78f713de65477722c69e437
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54
const $352d8776ce9e612e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "e2df23bdc78f713de65477722c69e437",
            "id": "a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54",
            "metadata": {},
            "name": "useSpaceViewsDataSpaceRootQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsDataSpaceRootQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$352d8776ce9e612e$var$node.hash = "0fe50aba41f4ffff776e7aeae840f990";
var $352d8776ce9e612e$export$2e2bcd8739ae039 = $352d8776ce9e612e$var$node;
module.exports["default"] = $352d8776ce9e612e$export$2e2bcd8739ae039;

});

parcelRegister("d4Pk4", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $985375b928439e07$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $985375b928439e07$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $985375b928439e07$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $985375b928439e07$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $985375b928439e07$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $985375b928439e07$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $985375b928439e07$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("c7GB4", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $iH7AG = parcelRequire("iH7AG");

var $dM0Qh = parcelRequire("dM0Qh");

var $lb1Mg = parcelRequire("lb1Mg");

var $a2xFu = parcelRequire("a2xFu");

var $a5Dk4 = parcelRequire("a5Dk4");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $a2xFu.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $eB56w.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $a5Dk4.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iH7AG.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $dM0Qh.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lb1Mg.ConfluenceFolderAri).parse(ari).folderId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("iH7AG", function(module, exports) {

var $hIjpx = parcelRequire("hIjpx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/database/manifest.ts
var $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hIjpx.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $hIjpx.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $d9c22183dba005c8$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $d9c22183dba005c8$export$317cd32472deea7e;

});

parcelRegister("hIjpx", function(module, exports) {
// src/confluence/database/types.ts
var $ce559a57d4ba003b$export$e83bc7b627335f1d = "confluence", $ce559a57d4ba003b$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $ce559a57d4ba003b$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $ce559a57d4ba003b$export$d26db9a1a0b750aa;

});

parcelRegister("dM0Qh", function(module, exports) {

var $dPsPU = parcelRequire("dPsPU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/embed/manifest.ts
var $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $dPsPU.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $dPsPU.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $a070694ffdc5cb3b$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $a070694ffdc5cb3b$export$47d4b4205d0ac61a;

});

parcelRegister("dPsPU", function(module, exports) {
// src/confluence/embed/types.ts
var $a116681263506e39$export$7a02af293cacddd2 = "confluence", $a116681263506e39$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $a116681263506e39$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $a116681263506e39$export$f817d48842ea0d4a;

});

parcelRegister("lb1Mg", function(module, exports) {

var $bYbE5 = parcelRequire("bYbE5");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/folder/manifest.ts
var $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bYbE5.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $bYbE5.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $f6ac010730fe9d5d$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $f6ac010730fe9d5d$export$501a782385a3f485;

});

parcelRegister("bYbE5", function(module, exports) {
// src/confluence/folder/types.ts
var $8b6e54dbbb0b2632$export$77cf4e1b17902bfa = "confluence", $8b6e54dbbb0b2632$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $8b6e54dbbb0b2632$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $8b6e54dbbb0b2632$export$6256ff329bc25a9c;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");


var $6mKj3 = parcelRequire("6mKj3");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$a586f466261ecb73 = ()=>{
    const baseRoutes = [
        (0, $1NBp8.DATABASE_VIEW).name,
        (0, $1NBp8.VIEW_PAGE).name,
        (0, $1NBp8.WHITEBOARD_BOARD).name,
        (0, $1NBp8.SLIDES_VIEW).name,
        (0, $1NBp8.EMBED_VIEW).name
    ];
    if ((0, $6mKj3.expValEquals)('cc-axp-delete-editing-page-redirect', 'isEnabled', true)) return [
        ...baseRoutes,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_PAGE_V2).name
    ];
    return baseRoutes;
};
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).WHITEBOARD
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["getDeleteSuccessRedirectRoutes"] = $2aa2bdb281c6889a$export$a586f466261ecb73;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("fdNea", function(module, exports) {

var $de4za = parcelRequire("de4za");


var $42omo = parcelRequire("42omo");


var $3TgYS = parcelRequire("3TgYS");


var $fFmJj = parcelRequire("fFmJj");

const $5be82f78ca966df2$var$useLocalActivityContentFragment = (0, $de4za.default);
const $5be82f78ca966df2$var$MAX_EVENTS = 100;
const $5be82f78ca966df2$var$contentIdsToBeEvicted = new Set();
const $5be82f78ca966df2$var$isMarkedForEviction = (event)=>$5be82f78ca966df2$var$contentIdsToBeEvicted.has(event.content.id || '');
const $5be82f78ca966df2$export$1b153e31f71ec597 = ({ filters: filters } = {})=>{
    const readLocalActivityContentFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $5be82f78ca966df2$var$useLocalActivityContentFragment
    });
    const dehydratedLocalActivities = (0, $3TgYS.useLocalActivityCache)();
    const localActivities = [];
    for (const event of dehydratedLocalActivities){
        const hydratedEvent = {
            ...event
        };
        try {
            if (event?.content?.id) {
                const contentFragment = readLocalActivityContentFragment({
                    id: `Content:${event.content.id}`
                });
                if (contentFragment) hydratedEvent.content = {
                    ...hydratedEvent.content,
                    ...contentFragment
                };
            }
        } catch  {
        // If the fragment does not exist, don't do anything this event will get filtered out
        }
        localActivities.push(hydratedEvent);
    }
    /**
   * Events which are marked as consistent for all backend APIs can safely be evicted.
   * At the time of writing, there is only 1 supported backend API (Activity Platform),
   * so we can immediately mark the event for eviction.
   *
   * This eviction is "lazy", meaning that the event is *marked* as evicted & filtered from the
   * result set, but not actually removed from memory until `trackLocalActivity` is called.
   */ const markAsConsistent = (0, $42omo.useCallback)((contentId)=>{
        $5be82f78ca966df2$var$contentIdsToBeEvicted.add(contentId);
    }, []);
    const result = {
        viewedEvents: [],
        deletedContentIds: new Set(),
        markAsConsistent: markAsConsistent
    };
    localActivities.forEach((event)=>{
        if (!$5be82f78ca966df2$var$shouldIncludeEvent(event, filters)) return;
        if (event.action === (0, $3TgYS.LocalActivityAction).viewed) result.viewedEvents.push(event);
        else if (event.action === (0, $3TgYS.LocalActivityAction).deleted) result.deletedContentIds.add(event.content.id || '');
    });
    return result;
};
const $5be82f78ca966df2$var$shouldIncludeEvent = (event, filters)=>{
    // Filter events which will be evicted
    if ($5be82f78ca966df2$var$isMarkedForEviction(event)) return false;
    if (!filters) return true;
    return filters.spaceKey === ('space' in event.content ? event.content.space?.key : undefined);
};
const $5be82f78ca966df2$export$3fa173aba6d1fb4b = ({ contentId: contentId, action: action }, setLocalActivity, getLocalActivity)=>{
    /**
   * The Content is dehydrated (i.e. only Content.id is present, not full Content)
   * because we may not know all Content data at track time.
   * The full Content will be hydrated from cache automatically when querying in useLocalActivity
   */ let dehydratedEvents = [];
    try {
        dehydratedEvents = getLocalActivity()?.filter((e)=>!$5be82f78ca966df2$var$isMarkedForEviction(e)).slice(0, $5be82f78ca966df2$var$MAX_EVENTS - 1) || [];
    } catch  {}
    $5be82f78ca966df2$var$contentIdsToBeEvicted.clear();
    const data = {
        localActivity: [
            {
                id: `${contentId}-${action}`,
                action: action,
                timestamp: new Date().toISOString(),
                content: {
                    id: contentId,
                    __typename: 'Content'
                },
                __typename: 'LocalActivityEvent'
            },
            ...dehydratedEvents
        ]
    };
    setLocalActivity(data.localActivity);
};
module.exports["useLocalActivity"] = $5be82f78ca966df2$export$1b153e31f71ec597;
module.exports["trackLocalActivity"] = $5be82f78ca966df2$export$3fa173aba6d1fb4b;

});

parcelRegister("de4za", function(module, exports) {
/**
 * @generated SignedSource<<de5a5e114e312b89a46ea47a834c86ef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b7736c1a4cd6fb8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useLocalActivityContentFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ 
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "emoji-title-published",
                            "emoji-title-draft"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v1 /*: any*/ ,
                            {
                                "concreteType": "Version",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "number"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
            }
        ],
        "type": "Content"
    };
}();
$2b7736c1a4cd6fb8$var$node.hash = "e057d047fb173be62229acfca15ccbce";
var $2b7736c1a4cd6fb8$export$2e2bcd8739ae039 = $2b7736c1a4cd6fb8$var$node;
module.exports["default"] = $2b7736c1a4cd6fb8$export$2e2bcd8739ae039;

});

parcelRegister("3TgYS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");

var $e8033b5fc56f919b$export$1e5f9e0e1f5f771c = /*#__PURE__*/ function(LocalActivityAction) {
    LocalActivityAction["deleted"] = "deleted";
    LocalActivityAction["viewed"] = "viewed";
    return LocalActivityAction;
}({});
const $e8033b5fc56f919b$export$c008b11c6b6e84c9 = (0, $1P1Tu.createStore)({
    name: 'localActivityStore',
    initialState: {
        localActivity: []
    },
    actions: {
        setLocalActivity: (localActivity)=>({ setState: setState })=>{
                setState({
                    localActivity: [
                        ...localActivity
                    ]
                });
            },
        getLocalActivity: ()=>({ getState: getState })=>{
                return getState().localActivity;
            }
    }
});
const $e8033b5fc56f919b$var$localActivitySelector = (0, $cclHy.createSelector)((state)=>state.localActivity, (localActivity)=>localActivity);
const $e8033b5fc56f919b$export$f16e1a8a1b5f5fcc = (0, $9zUhf.createStateHook)($e8033b5fc56f919b$export$c008b11c6b6e84c9, {
    selector: $e8033b5fc56f919b$var$localActivitySelector
});
const $e8033b5fc56f919b$export$b62470c19b810f2b = (0, $9zUhf.createActionsHook)($e8033b5fc56f919b$export$c008b11c6b6e84c9);
module.exports["LocalActivityAction"] = $e8033b5fc56f919b$export$1e5f9e0e1f5f771c;
module.exports["useLocalActivityCache"] = $e8033b5fc56f919b$export$f16e1a8a1b5f5fcc;
module.exports["useLocalActivityCacheStoreActions"] = $e8033b5fc56f919b$export$b62470c19b810f2b;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("ifD3G", function(module, exports) {

let $d497ece08760845d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d497ece08760845d$var$load("aCG0y").then(()=>parcelRequire('43701'));

});

parcelRegister("9XDXQ", function(module, exports) {

let $74089fd021e3d13d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $74089fd021e3d13d$var$load("cJcjb"),
    $74089fd021e3d13d$var$load("Wowvf"),
    $74089fd021e3d13d$var$load("1TYNY")
]).then(()=>parcelRequire('8h7F8'));

});

parcelRegister("xzydI", function(module, exports) {

let $064ea8dbba8f9020$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $064ea8dbba8f9020$var$load("guX1n").then(()=>parcelRequire('4xGyI'));

});

parcelRegister("4LZuC", function(module, exports) {

let $379b4069a3610801$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $379b4069a3610801$var$load("6wr18"),
    $379b4069a3610801$var$load("4mgLr"),
    $379b4069a3610801$var$load("ffEVr"),
    $379b4069a3610801$var$load("hhss7"),
    $379b4069a3610801$var$load("kJLy8")
]).then(()=>parcelRequire('amtnj'));

});

parcelRegister("cXwni", function(module, exports) {

let $96f41bb159a9a46d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96f41bb159a9a46d$var$load("SepNY").then(()=>parcelRequire('kb7fE'));

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});


//# sourceMappingURL=SpaceViews.d8e9204d.js.map
